<template>
    <v-container style="padding-top: 100px;">
        <v-flex xs12 sm12>
            <v-chip class="ma-2" :color="this.color" large>
                <span style="color: white;padding-right: 10px;font-size: 20px;"> Reporte: {{ this.RepInd }}</span>
                <div
                    style=" font-size: 16px; background-color: white; color:black; border-radius: 25px; padding: 6% 2% 6% 2%; font-weight: bold;">
                    {{ this.etiqueta }}</div>
            </v-chip>
        </v-flex>
        <v-card style="height: 50% !important; borde:none;" id="DatosGenerales">
            <v-tabs v-model="tabs" centered>
                <v-tab @click="pushTo('detalles')"> Detalle General </v-tab>
                <v-tab @click="pushTo('averPrevia')" v-if="proceso == 1"> Averiguación Previa</v-tab>
                <v-tab @click="pushTo('averPreviaLibVeh')" v-if="proceso == 2"> Averiguación Previa</v-tab>
                <v-tab @click="pushTo('documentos')">Documentos</v-tab>
                <v-tab> </v-tab>
            </v-tabs>
            <v-tabs-items class="container">
                <router-view></router-view>
            </v-tabs-items>
        </v-card>
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ReporteRobo from '@/services/asistenciaRobo/AsistenciaRobo.service.js';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";

export default {
    data: function () {
        return {
            tabs: '',
            RepInd: '',
            color: '',
            etiqueta: '',
            proceso: "",
        };
    },
    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        }
    },
    mounted() {
        this.getInitialData();
    },
    updated() {
        this.getInitialData();
    },
    methods: {
        async getInitialData() {
            let encabezado = await ReporteRobo.EncabezadoReporte(this);
            this.RepInd = encabezado.nrreportei;
            this.color = encabezado.color;
            this.etiqueta = encabezado.etiqueta;
            this.proceso = parseInt(encabezado.proceso);
        },
        pushTo(param) {
            switch (param) {
                case 'detalles':
                    this.$router.push({ name: `ReporteDetalleRobo` }).catch((error) => error);
                    break;
                case 'averPrevia':
                    this.$router.push({ name: `RoboAverPrev`, }).catch((error) => error);
                    break;
                case 'averPreviaLibVeh':
                    this.$router.push({ name: `AverPrevLibVeh`, }).catch((error) => error);
                    break;
                case 'documentos':
                    this.$router.push({ name: `documentosRobo` }).catch(error => error);
                    break;
            }
        },
    }
};
</script>

<style lang="scss">
.v-card__text {
    align-content: center;
    padding-top: 10px !important;
}

#menu_reporte .v-toolbar__content {
    height: 0px !important;
}

#menu_reporte {
    height: 50% !important;
}

#custom-tab-items {
    background-color: transparent !important;
}

#DatosGenerales .v-toolbar__title {
    font-size: 24px;
}

#DatosGenerales .v-list-item__title {
    font-size: 18px;
    /*font-weight: bold;*/
}

#DatosGenerales span.font-weight-bold {
    font-size: 18px;
}

.container {
    max-width: 2536px !important;
}

.vs-list--title {
    font-size: 20px;
}

.vs-list--subtitle {
    font-size: 16px;
}

.mdi-check-circle-outline {
    color: #3CD4A0 !important;
}

.mdi-checkbox-marked {
    color: #3CD4A0 !important;
}

.mdi-file-document,
.mdi-car-info,
.mdi-card-account-phone,
.mdi-alert-octagon,
.mdi-doctor,
.mdi-folder-alert,
.mdi-badge-account-alert,
.mdi-text-box-multiple-outline,
.mdi-bank,
.mdi-school,
.mdi-archive,
.mdi-school-outline,
.mdi-badge-account-alert-outline,
.mdi-information-outline,
.mdi-map-marker-radius,
.mdi-account-supervisor,
.mdi-calendar,
.mdi-car,
.mdi-calendar-clock,
.mdi-email {
    color: white !important;
}

#DetalleReporte .vs-list--subtitle {
    font-size: 20px;
    font-weight: 700;
}

#DetalleReporte .vs-list--title {
    font-size: 12.8px;
    font-weight: 700;
}

#titulocard {
    color: white;
}
</style>